import { render } from "./StatusMovingIcon.vue?vue&type=template&id=b16a705c"
import script from "./StatusMovingIcon.vue?vue&type=script&lang=js"
export * from "./StatusMovingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__